import type { TranslationDict } from '../en';

const tr: TranslationDict = {
  'header.buy': 'Al',
  'header.sell': 'Sat',
  'spend.label': 'Harcadığınız',
  'spend.placeholderFiat': '250',
  'spend.placeholderCrypto': '0.01',
  'receive.label': 'Alacağınız',
  'payment.label': 'Ödeme yöntemi',
  'payment.select': 'Seç',
  'provider.label': 'By',
  'provider.select': 'Select',
  'provider.unavailable': 'Unavailable',
  'provider.unavailablePayment': 'Payment method not supported',
  'provider.unavailableCountry': 'Region not supported',
  'provider.unavailableCurrency': 'Currency not supported',
  'provider.unavailableNetwork': 'Network not supported',
  'payment.noneAvailable': 'Bu çift için ödeme yöntemi yok',
  'wallet.label': 'Alıcı cüzdan adresi',
  'wallet.placeholderBuy': 'Alıcı adresinizi girin',
  'wallet.placeholderSell': 'Gönderici adresinizi girin',
  'wallet.validating': 'Adres doğrulanıyor...',
  'wallet.invalid': 'Geçerli bir cüzdan adresi girin',
  'wallet.invalidServer': 'Geçersiz cüzdan adresi',
  'cta.buy': '{crypto} Al',
  'cta.sell': '{crypto} Sat',
  'cta.gettingPrice': 'En iyi fiyat alınıyor...',
  'cta.processing': 'İşleniyor...',
  'footer.poweredBy': 'Altyapı: ',
  'footer.brand': 'NowRamp',
  'rate.title': 'Oran detayları',
  'rate.close': 'Kapat',
  'rate.updatesIn': 'Oran 00:{seconds} içinde güncellenir',
  'rate.noQuote': 'Teklif mevcut değil',
  'rate.exchangeRate': 'Döviz kuru',
  'rate.processingFee': 'İşlem ücreti',
  'rate.networkFee': 'Ağ ücreti',
  'rate.provider': 'Sağlayıcı',
  'toast.orderCreated': 'Sipariş oluşturuldu',
  'toast.redirecting': 'Ödemeye yönlendiriliyor...',
  'toast.orderFailed': 'Sipariş başarısız',
  'toast.couldNotCreate': 'Sipariş oluşturulamadı',
  'toast.quoteError': 'Teklif hatası',
  'toast.noProviders': 'Sağlayıcı yok',
  'toast.somethingWrong': 'Bir şeyler ters gitti',
  'error.amountZero': 'Tutar 0\'dan büyük olmalıdır',
  'error.minAmountFiat': 'Minimum tutar {min} {currency}',
  'error.minAmountCrypto': 'Minimum tutar {min} {currency}',
  'error.noProviders': 'Bu kombinasyon için kullanılabilir sağlayıcı yok',
  'error.currencyUnavailableBuy': 'Bu para birimi alış siparişleri için kullanılamaz',
  'error.currencyUnavailableSell': 'Bu para birimi satış siparişleri için kullanılamaz',
  'parity.info': '{receiveAmount} {crypto} için ücretlendirileceksiniz, {spendAmount} {fiat} tutarına kadar olan fark {partner} hesabınıza aktarılacaktır',
  'redirect.secureBadge': 'Güvenli ödeme',
  'redirect.title': 'Ödemeye Devam Et',
  'redirect.description': 'Ödemenizi tamamlamak için {gateway} sayfasına yönlendirileceksiniz.',
  'redirect.countdown': '{seconds} içinde yönlendiriliyor...',
  'redirect.openTab': 'ACH\'yi yeni sekmede aç',
  'redirect.cancel': 'İptal',
  'checkout.noOrder': 'Sipariş bulunamadı',
  'checkout.goBack': 'Geri Dön',
  'checkout.expired': 'Ödeme süresi doldu',
  'checkout.expiredDesc': 'Oturum süresi doldu. Lütfen tekrar deneyin.',
  'checkout.startOver': 'Baştan başla',
  'checkout.cancel': 'İptal',
  'checkout.loading': 'Ödeme yükleniyor...',
  'checkout.iframeTitle': 'Sağlayıcı Ödeme Sayfası',
  'checkout.widgetTitle': 'Ödeme Sayfası',
  'checkout.unknownMethod': 'Bilinmeyen ödeme yöntemi',
  'processing.default': 'Siparişiniz işleniyor...',
  'processing.pending': 'Ödeme onayı bekleniyor...',
  'processing.active': 'İşleminiz gerçekleştiriliyor...',
  'processing.generic': 'İşleniyor...',
  'processing.checkingStatus': 'Durum kontrol ediliyor...',
  'processing.orderId': 'Sipariş No',
  'processing.provider': 'Sağlayıcı',
  'processing.amount': 'Tutar',
  'processing.receiving': 'Alınan',
  'processing.network': 'Ağ',
  'processing.toAddress': 'Hedef Adres',
  'processing.usuallyMinutes': 'Bu genellikle birkaç dakika sürer.',
  'processing.safeToClose': 'Bu sayfayı güvenle kapatabilirsiniz - tamamlandığında size e-posta göndereceğiz.',
  'complete.buyTitle': 'Satın Alma Tamamlandı!',
  'complete.sellTitle': 'Satış Tamamlandı!',
  'complete.buyDesc': '{crypto} cüzdanınıza gönderildi.',
  'complete.sellDesc': '{fiat} ödemeniz işleniyor.',
  'complete.amountBuy': 'Alınan Tutar',
  'complete.amountSell': 'Satılan Tutar',
  'complete.paidBuy': 'Ödenen Tutar',
  'complete.paidSell': 'Ödeme Tutarı',
  'complete.network': 'Ağ',
  'complete.wallet': 'Cüzdan',
  'complete.transaction': 'İşlem',
  'complete.provider': 'Sağlayıcı',
  'complete.orderId': 'Sipariş No',
  'complete.completed': 'Tamamlandı',
  'complete.viewExplorer': 'Gezginde Görüntüle',
  'complete.done': 'Tamam',
  'errorStep.failed': 'Ödeme Başarısız',
  'errorStep.cancelled': 'Sipariş İptal Edildi',
  'errorStep.expired': 'Sipariş Süresi Doldu',
  'errorStep.refunded': 'Sipariş İade Edildi',
  'errorStep.unknown': 'Bir Şeyler Ters Gitti',
  'errorStep.failedBuy': 'Ödemeniz işlenemedi. Lütfen tekrar deneyin veya farklı bir ödeme yöntemi kullanın.',
  'errorStep.failedSell': 'Satışınız işlenemedi. Lütfen tekrar deneyin.',
  'errorStep.cancelledBuy': 'Siparişiniz iptal edildi. Herhangi bir ödeme işlenmedi.',
  'errorStep.cancelledSell': 'Satışınız iptal edildi. Herhangi bir kripto transfer edilmedi.',
  'errorStep.expiredBuy': 'Siparişinizin süresi doldu. Lütfen yeni bir satın alma başlatın.',
  'errorStep.expiredSell': 'Siparişinizin süresi doldu. Lütfen yeni bir satış başlatın.',
  'errorStep.refundedBuy': 'Ödemeniz iade edildi. Tutar 5-10 iş günü içinde hesabınızda görünecektir.',
  'errorStep.refundedSell': 'Kriptonuz iade edildi. Tutar kısa süre içinde cüzdanınızda görünecektir.',
  'errorStep.genericDesc': 'Beklenmeyen bir hata oluştu. Lütfen tekrar deneyin.',
  'errorStep.orderId': 'Sipariş No',
  'errorStep.tryAgain': 'Tekrar Dene',
  'errorStep.startOver': 'Baştan Başla',
  'errorStep.return': 'Geri Dön',
  'errorStep.needHelp': 'Yardıma mı ihtiyacınız var? İletişim: ',
  'errorStep.reference': 'Referans: {orderId}',
  'confirm.buyTitle': 'Satın Almayı Onayla',
  'confirm.sellTitle': 'Satışı Onayla',
  'confirm.loading': 'Yükleniyor...',
  'confirm.provider': 'Sağlayıcı',
  'confirm.youPay': 'Ödediğiniz',
  'confirm.youSell': 'Sattığınız',
  'confirm.youReceive': 'Alacağınız',
  'confirm.wallet': 'Cüzdan',
  'confirm.network': 'Ağ',
  'confirm.refundAddress': 'İade adresi',
  'confirm.parityNote': 'Sağlayıcıdan alınan tutar farklı olabilir. Kalan {amount} {crypto} tutarına kadar {partner} hesabınıza aktarılacaktır.',
  'confirm.processing': 'İşleniyor...',
  'confirm.confirmPay': 'Onayla ve Öde',
  'confirm.confirmSell': 'Onayla ve Sat',
  'confirm.payout': '{currency} ödemesi',
  'modal.selectFiat': 'Fiat para birimi seçin',
  'modal.selectCrypto': 'Kripto para birimi seçin',
  'modal.choosePayment': 'Ödeme yöntemi seçin',
  'modal.selectCountry': 'Ülkenizi seçin',
  'modal.selectLanguage': 'Select language',
  'modal.popular': 'Popüler',
  'modal.recommended': 'Önerilen',
  'modal.noCurrencies': 'Para birimi bulunamadı',
  'modal.noPaymentMethods': 'Ödeme yöntemi bulunamadı',
  'modal.noCountries': 'Ülke bulunamadı',
  'modal.noLanguages': 'No languages found',
  'settings.location': 'Konum',
  'settings.darkMode': 'Karanlık Mod',
  'settings.privacy': 'Gizlilik politikası',
  'settings.terms': 'Kullanım koşulları',
  'settings.language': 'Dil',
  // ─── Additional ───
  'modal.chooseRamp': 'Ramp Seçin',
  'modal.bestPrice': 'En iyi fiyat',
  'modal.noQuotes': 'Bu istek için teklif yok',
  'modal.noProvidersFound': 'Sağlayıcı bulunamadı',
  'payment.unavailableFor': '{currency} için ödeme yöntemi yok',
  'skeleton.poweredBy': 'NowRamp tarafından desteklenmektedir',
  'error.createOrderFailed': 'Sipariş oluşturulamadı',
  'errorStep.returnToMerchant': 'Satıcıya dön',
  'confirm.cryptoOnNetwork': '{crypto} {network} üzerinde',
  'payment.name.card': 'Kart',
  'payment.name.bankTransfer': 'Banka Transferi',
  'payment.name.ach': 'ACH',
  'rate.updatesInLabel': 'Rate updates in',
  'rate.networkFeeIncl': 'Network fee incl.',
  'rate.rateTooltip': 'As the market is highly volatile, we can fix the exchange rate for no longer than 30 seconds.',
  'rate.networkFeeTooltip': 'Includes a fee charged by blockchain to execute the transaction.',
  'rate.feeIncluded': '{percentage}% incl.',
  'receive.fetchingRate': 'Fetching best rate...',
  'redirect.tabHelper': 'If the new tab has not opened, click the button above.',
};

export default tr;
